<template>
  <div>
    <div>
      <p>At BlockChyp we know you've learned the hard way not to trust payment processors.
      To help merchants and demonstrate our commitment to transparency, we provide
      access to simple price shopping tools and a detailed statement analysis tool
      absolutely free.  <a href="https://www.blockchyp.com/contact" target="_blank" rel="noopener">Here</a> you can analyze your
      statements totally anonymously with no pressure.  We're here if you need us,
      but you don't have to talk to anyone to get the answers you need. <b>Just enter your
      monthly volume and transaction count to get started with a simple estimate.</b>
      If you have a statement, you can enter details later.</p>
    </div>
    <div class="card">
      <h5 class="card-header">
        <span v-if="!job.id">Get Your Fee Estimates</span>
        <span v-if="job.id">Your Fee Estimates</span>

        <a v-if="job.id" class="btn-recalc mg-l-5 float-right btn btn-sm btn-success" @click="toggleShare()"><i class="fas fa-share-alt"></i> SHARE</a>
        <a class="btn-recalc mg-l-5 float-right btn btn-sm btn-danger" @click="recalc()"><i class="fas fa-sync"></i> CALCULATE</a>
      </h5>
      <div class="shareBlock" v-if="shareEnabled">
        <div class="form-inline float-right mg-5 mg-t-10">

          <div class="input-group mb-2 mr-sm-2">
            <input readonly  id="statementLink" class="form-control form-control-sm linkBox" :value="job.shareLink"/>
            <div class="input-group-append">
              <span class="input-group-text" @click="copyLink()"><i class="fas fa-clipboard"></i></span>
            </div>
          </div>
          <!-- <a class="btn btn-sm mg-b-5 btn-info"><i class="fas fa-envelope"></i> EMAIL</a> -->
        </div>

      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label">Monthly Volume:</label>
              <currency-input v-model="job.volume" @blur="recalc()"/>
              <div class="text-muted">The total amount of credit card processing you do in a month.</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-control-label">Enter Transaction Count:</label>
              <input class="form-control" v-model="job.transactionCount" @blur="recalcFromCount()"/>
              <div class="text-muted">The number of transactions you do in a month.</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-control-label">Or Average Transaction:</label>
              <currency-input v-model="job.averageTransaction" @blur="recalcFromAvg()"/>
              <div class="text-muted">The average ticket amount.</div>
            </div>
          </div>
        </div>
        <div class="row" v-if="job.averageTransaction">

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label">Estimated Interchange:</label>
              <percent-input percentMode="true" v-model="job.averageInterchange" @blur="recalc()"/>
              <div class="text-muted">
                These are the fees charged by the card issuing banks.
              </div>


            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label">Estimated Assessments:</label>
              <percent-input percentMode="true" v-model="job.averageAssessments" @blur="recalc()"/>
              <div class="text-muted">These are fees charged by the card brands.</div>

            </div>
          </div>
        </div>
      <div class="row">
        <div class="col-md-6">
        </div>
        <div class="col-md-6">
          <!--
          <a class="btn float-right btn-info btn-sm" @click="addStatementRoute()"><i class="fas fa-file-invoice-dollar"></i> ADD STATEMENT DETAILS</a>
          -->
        </div>
      </div>
    </div>
    </div> <!-- card -->
    <div class="mg-t-20 alert alert-danger" v-if="job.errorMessages">
      <ul>
        <li v-for="msg in job.errorMessages" v-bind:key="msg">{{msg}}</li>
      </ul>
    </div>
    <div class="card mg-t-20" v-if="job.options">
      <h5 class="card-header">
        Pricing Comparisons
        <a class="btn-recalc mg-l-5 float-right btn btn-sm btn-danger" @click="recalc()"><i class="fas fa-sync"></i> CALCULATE</a>
        <input id="inviteCode" class="form-control  form-control-sm float-right" v-model="job.inviteCode" placeholder="INVITE CODE" @blur="recalc()"/>
      </h5>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Processor</th>
              <th scope="col" class="text-center">Base Rate</th>
              <th scope="col" class="text-right">Monthly Fee</th>
              <th scope="col" class="text-right">Total Fees</th>
              <th scope="col" class="text-right">Cost Per T/X</th>
              <th scope="col" class="text-right">Estimated Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="option in job.options" v-bind:key="option.processorId">
              <th scope="row">
                <div v-if="!option.isCurrent">{{option.processorName}}</div>
                <div v-if="option.isCurrent"><router-link :to="'/statement-detail/' + option.processorId">{{option.processorName}}</router-link></div>
                <div><small>{{option.programNotes}}</small></div>
              </th>
              <td class="text-center">
                <div v-if="option.isCurrent">
                  <div v-if="option.isStatement">
                    <small v-if="option.pricingType === 'interchange-plus'">interchange and assessments plus</small>
                    <div class="font-weight-bold">{{option.baseRateDescription}}</div>
                  </div>
                  <div v-if="!option.isStatement">
                    <small><router-link :to="'/statement-detail/' + option.processorId">Add a statement</router-link> for <br/>more accurate rate numbers.</small>
                  </div>
                </div>
                <div v-if="!option.isCurrent">
                  <small v-if="option.pricingType === 'interchange-plus'">interchange and assessments plus</small>
                  <div class="font-weight-bold">{{option.baseRateDescription}}</div>
                </div>
              </td>
              <td class="text-right">${{option.monthlyFee}}</td>
              <td class="text-right">${{option.totalFees}}</td>
              <td class="text-right">${{option.costPerTransaction}}</td>
              <td class="text-right effRate">{{option.effectiveRate}}%</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!newProcVisible">
          <!--
          <button type="button" @click="showAddProc()" class="btn btn-sm btn-info">ADD ANOTHER PROCESSOR</button>
          -->
        </div>
        <div class="alert alert-info" v-if="newProcVisible">
           <form @submit="addNewProcessor">
             <div class="row newProcRow">
               <div class="col-md-3">
                 <div class="form-group">
                   <label class="form-control-label"><b>Your Current Processor:</b></label>
                   <input class="form-control" v-model="newProcessorName" placeholder="Processor Name" required/>
                   <div class="text-muted">The name of your current processor. Profanity optional.</div>
                 </div>
               </div>
               <div class="col-md-3">
                 <div class="form-group">
                   <label class="form-control-label"><b>The Total You <em>Actually</em> Paid In Fees:</b></label>
                   <currency-input v-model="newProcessorFees"/>
                   <div class="text-muted">If you can find it on your statement.  They don't make it easy.</div>
                 </div>
               </div>
               <div class="col-md-3">
                 <div class="form-group">
                   <label class="form-control-label"><b>Rate Type:</b></label>
                   <select class="form-control" v-model="newProcessorPricingType">
                     <option value="interchange-plus">Interchange Plus</option>
                   </select>
                   <div class="text-muted">Just accept the defaults if you're not sure.</div>
                 </div>
               </div>
               <div class="col-md-2">
                 <button type="submit" class="btn btn-sm btn-danger mg-t-35">ADD PROCESSOR</button>
               </div>
             </div>

         </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from './../router'
import axios from 'axios'
import CurrencyInput from '@blockchyp/crud-magic/src/widgets/CurrencyInput'
import PercentInput from '@/components/PercentInput'

export default {
  name: 'AnalyzerRoot',
  props: ['id'],
  components: {
    'currency-input': CurrencyInput,
    'percent-input': PercentInput
  },
  data: () => ({
    newProcVisible: true,
    shareEnabled: false,
    newProcessorName: null,
    newProcessorFees: null,
    newProcessorPricingType: 'interchange-plus',
    job: {
      id: null,
      averageTransaction: ''
    }
  }),
  methods: {
    addStatementRoute() {

      for (var i = 0; i < this.job.options; i++) {
        var option = this.job.options[i]
        if (option.processorId) {
          router.push('/statement-detail/' + option.processorId)
        }
      }

      router.push('/statement-detail?jobId=' + this.job.id)
    },
    showAddProc: function () {
      this.newProcVisible = true
    },
    updateJobState: function () {

      if (!this.id) {
        //makes the back button work once they start entering statements
        router.push('/statement/' + this.job.id)
      } else {
        if (this.job.hasCurrentProcessors) {
          this.newProcVisible = false
        }
      }
    },
    addNewProcessor: function (e) {
      e.preventDefault()
      let self = this
      let proc = {
        jobId: this.job.id,
        name: self.newProcessorName,
        pricingType: self.newProcessorPricingType,
        totalFees: self.newProcessorFees
      }
      axios.post('/api/analyze-current-processor', proc)
        .then(function (response) {
          self.job = response.data
          self.newProcessorName = null
          self.newProcessorFees = null
          self.updateJobState()
        })
        .catch(function (error) {
          console.log(error)
        })


    },
    copyLink: function () {
      var element = document.getElementById("statementLink")
      element.select()
      document.execCommand("copy")
    },
    toggleShare: function() {
      this.shareEnabled = !this.shareEnabled
    },
    recalcFromAvg: function () {

      let amount = parseFloat(this.job.volume)
      let avg = parseFloat(this.job.averageTransaction)
      if (avg > 0) {
        let count = Math.round(amount / avg)
        this.job.transactionCount = count.toString()
      }

      this.recalc()
    },
    recalcFromCount: function () {
      //TODO stuff
      this.recalc()
    },
    recalc: function () {
      let self = this
      axios.post('/api/analyze-job', self.job)
        .then(function (response) {
          self.job = response.data
          self.updateJobState()
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted () {
    this.$emit("captionChange", "PROCESSING FEE COMPARISON TOOL")
    if (this.id) {
      let self = this
      axios.get('/api/analyze-job/' + this.id)
        .then(function (response) {
          self.job = response.data
          self.updateJobState()
        })
        .catch(function (error) {
          console.log(error)
        })

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn-recalc {
  color: white !important;
}

.shareBlock {
  border-top: solid 1px black;
  border-bottom: solid 1px black;
  margin-left: 0 !important;
}

.shareBlock .btn {
    color: white !important;
}

.linkBox {
  min-width: 500px;
  margin-right: auto;
}

.effRate {
  font-weight: bold;
  font-size: 15pt;
}

#inviteCode {
  max-width: 150px;
}

.newProcRow .text-muted {
  font-size: 9pt;
}

</style>
